<template>
	<div class="mr-2 mw-320px mt-2">
		<div class="upload-box">
		    <span>
		    	<i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState('waypoints')">Upload from media library</a>
		    </span>
		</div>

	</div>
</template>

<script>

export default {
	components: {},
	props: [
		'form',
		'changeUploadBoxState',
		'errors'
	]
}
</script>
